// extracted by mini-css-extract-plugin
export default {"heading":"YEuQMwAFHjtCI6CyBW-pB","button":"_1-3wmUayVaGrskIfr3piRb","inputAnalytics":"_3gB2HIy72emlF5-xXe7YhS"};